import { styled } from '../../utils/styled'

export const StyledNotificationBadgeContainer = styled('div')`
  position: relative;
  display: inline-block;
`

export const StyledNotificationContainer = styled('div')`
  position: absolute;
  top: -10px;
  right: -10px;
`
